import firebase from "firebase";
import "firebase/auth";
import "firebase/analytics";

const config = {
  apiKey: "AIzaSyCVPEGoK92BrxurrhaWvSqWvTGbXaOp9Ps",
  authDomain: "nodam-street.firebaseapp.com",
  databaseURL: "https://nodam-street.firebaseio.com",
  projectId: "nodam-street",
  storageBucket: "nodam-street.appspot.com",
  messagingSenderId: "433569899637",
  appId: "1:433569899637:web:ddf44e4c5a3abee786043c",
  measurementId: "G-LE0MXZ9FGH",
};

// Initialize Firebase
firebase.initializeApp(config);
firebase.analytics();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const storageRef = storage.ref();
export const db = firebase.firestore();
export const analytics = firebase.analytics();

export default firebase;
